export default __webpack_public_path__ + "static/media/alertIconSemSobra.ba0d465e.svg";